import React, { useState, useEffect } from "react";
import _ from 'lodash';
  const DateInputFormat = React.forwardRef(({ value,onChange,onClick,onFocus,onKeyDown,id, name, autoFocus, placeholder, disabled, autoComplete, className, readOnly, required, tabIndex }, ref) => {

    return (
      <div className="input-group input-date date">
        <input
          ref={ref} 
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          className={className}
          name={name}
        />
        <span className="input-group-addon" onClick={onClick}>
          <i className='fas fa-calendar-alt'></i>
        </span>
      </div>
    )
  });

  const TimeInputFormat = React.forwardRef(({ value,onChange,onClick,onFocus,onKeyDown,id, name, autoFocus, placeholder, disabled, autoComplete, className, readOnly, required, tabIndex }, ref) => {
    

    return (
      <div className="input-group input-date date">
        <input
          ref={ref} 
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          className={className}
          name={name}
        />
        <span className="input-group-addon" onClick={onClick}>
          <i className='fas fa-clock'></i>
        </span>
      </div>
    )
  });


export {
  TimeInputFormat,
  DateInputFormat
}